export function scrollToTop() {
    const isSmoothScrollSupported =
        'scrollBehavior' in document.documentElement.style;
    if (isSmoothScrollSupported) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } else {
        window.scrollTo(0, 0);
    }
}
